import { ChangeDetectionStrategy, Component, Input, inject } from "@angular/core";
import {
  GoogleAnalyticsConstantsCategory,
  GoogleAnalyticsConstantsEvents,
} from "../../../shared/model/google-analytics-constants";
import { GoogleAnalyticsService } from "../../../shared/services/google-analytics.service";
import { VIEWER_SERVICE } from "../../services/internal-services/viewer-services/inject-base-viewer.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-infrared-selector",
  templateUrl: "./infrared-selector.component.html",
  styleUrls: ["./infrared-selector.component.scss"],

  standalone: false,
})
export class InfraredSelectorComponent {
  viewerService = inject(VIEWER_SERVICE);

  displayPanel: boolean = false;

  @Input()
  active: boolean = false;

  @Input()
  enabled: boolean = false;

  @Input()
  set activeTrigger(active: boolean) {
    if (!!active && active !== this.active) {
      this.toggleInfraredStatus();
    }
  }

  constructor(protected googleAnalyticsService: GoogleAnalyticsService) {}

  toggleInfraredStatus() {
    this.active = this.viewerService.toggleInfrared();
    this.viewerService.updateLocationInfo();
    this.googleAnalyticsService.setGoogleAnalyticsEvent(
      GoogleAnalyticsConstantsEvents.TOGGLE_INFRARED_2D,
      GoogleAnalyticsConstantsCategory.COLLECTION_CONTROLLER,
      this.active,
    );
  }
}
